<script>
	import { Router, Route } from 'svelte-routing'

	import TaskIndex from './tasks/index.svelte'
	import TaskEdit from './tasks/edit.svelte'
	import TaskShow from './tasks/show.svelte'
	import TaskCreate from './tasks/create.svelte'
	
	import AgentIndex from './agents/index.svelte'
	import AgentCreate from './agents/create.svelte'
	import AgentEdit from './agents/edit.svelte'

	import ProjectIndex from './projects/index.svelte'
	import ProjectCreate from './projects/create.svelte'
	import ProjectEdit from './projects/edit.svelte'

	import { currentUser } from '../stores/current_user'

	const url = ''

</script>

<Router url={url}>
	<Route path="/" component={TaskIndex} />
	{#if $currentUser}
	<Route path="/tasks" component={TaskIndex} />
	<Route path="/tasks/edit/:id" component={TaskEdit} />
	<Route path="/tasks/show/:id" component={TaskShow} />
	<Route path="/tasks/create" component={TaskCreate} />
	
	<Route path="/agents" component={AgentIndex} />
	<Route path="/agents/create" component={AgentCreate} />
	<Route path="/agents/edit/:id" component={AgentEdit} />

	<Route path="/projects" component={ProjectIndex} />
	<Route path="/projects/create" component={ProjectCreate} />
	<Route path="/projects/edit/:id" component={ProjectEdit} />
	{/if}
</Router>
